import { render, staticRenderFns } from "./Audit.vue?vue&type=template&id=5bc988b9&scoped=true"
import script from "./Audit.vue?vue&type=script&lang=js"
export * from "./Audit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc988b9",
  null
  
)

export default component.exports